import { KontoService } from './../api/konto.service';
import { Component, OnInit } from '@angular/core';
import { Konto } from '../api/konto';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-kontos',
  templateUrl: './kontos.component.html',
  styleUrls: ['./kontos.component.scss']
})
export class KontosComponent implements OnInit {
  public kontos: Array<Konto> = [];

  constructor(public kontoService: KontoService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.kontoService.getKontos().subscribe(
      (kontos: Array<Konto>) => {
        this.kontos = kontos;
      }
    )
  }

  public onClickBearbeiten(konto: Konto): void {
    this.router.navigate(['kontos/', konto.id]); 
  }

  public onClickZuDenBuchungen(konto: Konto): void {
    this.router.navigate(['buchungen'], { queryParams: { konto: konto.id }});
  }
}
